<template>
  <div class="container">
    <Header
      :name="$t('app.profil.header')"
    />
    <transition mode="out-in" name="fade">
      <div class="primary-container">
        <div class="content-container">
          <Informations></Informations>
          <div class="links-container">
            <a href="https://yuzu.hr/legal/cgu.pdf" target="_blank">
              {{ $t("app.profil.termsOfService") }}
            </a>
            <a href="https://yuzu.hr/legal/privacy.pdf" target="_blank">
              {{ $t("app.profil.privacyPolicy") }}
            </a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import Header from "@/components/Header.vue";
import Informations from "./partials/Informations.vue";
</script>